import React from "react";
import { Helmet } from "react-helmet-async";

import { Game } from "../../models/Game";
import { User } from "../../models/User";
import { GameState } from "../../models/Enums";
import { FriendWrapperPopup } from "./FriendPopup/FriendWrapperPopup";
import { FriendBlockUserAuthorized } from "./FriendBlockUserAuthorized";
import { FriendBlockUserNotAuthorized } from "./FriendBlockUserNotAuthorized";

import styles from "./FriendContainer.css";

type FriendContainerProps = {
  game: Game;
  gameState: GameState;
  user: User;
};

export class FriendContainer extends React.Component<FriendContainerProps> {
  render() {
    const { user, gameState, game } = this.props;

    if (gameState === GameState.PENDING) {
      return null;
    }

    return (
      <React.Fragment>
        <Helmet
          link={[
            { rel: "stylesheet", href: "https://use.typekit.net/bjs6uer.css" },
          ]}
        />
        <Container data-element-description="Private Friends Network Global Container">
          <FriendWrapperPopup user={user} />

          {/* User Not Authorized  block */}
          {!user && <FriendBlockUserNotAuthorized />}

          {/* User Authorized block */}
          {user && <FriendBlockUserAuthorized user={user} game={game} />}
        </Container>
      </React.Fragment>
    );
  }
}

const Container = (props: any) => (
  <div className={styles.container} {...props} />
);
